import { useContext, useEffect } from 'react';

import { HubConnectionState } from '@microsoft/signalr';

import { SignalRConnectionContext, useOnSignalRMethod } from 'SignalR';
import { useAppDispatch, useAppSelector } from 'Store';

import { selectCoursesIds } from './selectors';
import { courseTrainerAllowedToPreview, isFreshStartMachineReadyToClone } from './slice';

export const useJoinCoursesListGroup = () => {
  const { connection, state } = useContext(SignalRConnectionContext);
  const dispatch = useAppDispatch();
  const courseIds = useAppSelector(selectCoursesIds);

  useOnSignalRMethod('CourseTrainerAllowedToPreview', (courseId: string, value: boolean) => {
    dispatch(courseTrainerAllowedToPreview({ courseId, value }));
  });

  useOnSignalRMethod('IsFreshStartMachineReadyToClone', (courseId: string, value: boolean) => {
    dispatch(isFreshStartMachineReadyToClone({ courseId, value }));
  });

  useEffect(() => {
    if (state !== HubConnectionState.Connected || courseIds.length === 0) {
      return;
    }

    let isJoined = false;

    const joinCoursesListGroup = async () => {
      try {
        await connection.invoke('JoinCoursesListGroup', courseIds);
        isJoined = true;
      } catch (error) {
        console.error('Failed to join courses list group:', error, { courseIds });
      }
    };

    const leaveCoursesListGroup = async () => {
      if (isJoined && courseIds.length > 0) {
        try {
          await connection.invoke('LeaveCoursesListGroup', courseIds);
        } catch (error) {
          console.error('Failed to leave courses list group:', error, { courseIds });
        }
      }
    };

    joinCoursesListGroup();

    return () => {
      leaveCoursesListGroup();
    };
  }, [connection, courseIds, state]);
};
